// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iPBzN","rootMobile":"styles_rootMobile__2Q51M"};